{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/site-logo",
	"title": "Site Logo",
	"category": "theme",
	"description": "Display an image to represent this site. Update this block and the changes apply everywhere.",
	"textdomain": "default",
	"attributes": {
		"width": {
			"type": "number"
		},
		"isLink": {
			"type": "boolean",
			"default": true,
			"role": "content"
		},
		"linkTarget": {
			"type": "string",
			"default": "_self",
			"role": "content"
		},
		"shouldSyncIcon": {
			"type": "boolean"
		}
	},
	"example": {
		"viewportWidth": 500,
		"attributes": {
			"width": 350,
			"className": "block-editor-block-types-list__site-logo-example"
		}
	},
	"supports": {
		"html": false,
		"align": true,
		"alignWide": false,
		"color": {
			"text": false,
			"background": false
		},
		"spacing": {
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"filter": {
			"duotone": true
		}
	},
	"styles": [
		{
			"name": "default",
			"label": "Default",
			"isDefault": true
		},
		{ "name": "rounded", "label": "Rounded" }
	],
	"selectors": {
		"filter": {
			"duotone": ".wp-block-site-logo img, .wp-block-site-logo .components-placeholder__illustration, .wp-block-site-logo .components-placeholder::before"
		}
	},
	"editorStyle": "wp-block-site-logo-editor",
	"style": "wp-block-site-logo"
}
